import React from "react";

const Toggle = ({ handleChange, isChecked }) => {
  return (
    <label className="toggle-container">
      <input
        type="checkbox"
        className="toggle"
        onChange={handleChange}
        checked={isChecked}
        aria-label="Dark mode"
      />
      <span className="toggle-switch" aria-hidden="true" />
    </label>
  );
};

export default Toggle;
